import { UPDATE_INFO_SCHEDULE } from '~/store/actions/ScheduleAction/type';

const initState = {
    infoSchedule: {},
};

const ScheduleReducer = (state = initState, action) => {
    switch (action.type) {
        case UPDATE_INFO_SCHEDULE: {
            let newState = { ...state };
            const newCart = action.payload;
            newState.infoSchedule = newCart;
            return newState;
        }

        default:
            return state;
    }
};

export default ScheduleReducer;
